import React from 'react';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { getRegion } from 'utils/Region';
import { ClaroTVLogo } from '../ClaroTVLogo';

export const QRLinkingErrorHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="QRLinkingErrorHeader">
      <ClaroTVLogo
        isTV
        onClick={() => navigate(`/${getRegion()}/landing`, { replace: true })}
      />
    </div>
  );
};
